import { SuperbetRouteConfig } from '@superbet-group/web.types';

import { accountRoutes } from '@app/router/routes/account';
import { bingoBashRoutes } from '@app/router/routes/bingoBash';
import { fantasticDuelsRoutes } from '@app/router/routes/fantasticDuels';
import { freeGamesRoutes } from '@app/router/routes/freeGames';
import { loyaltyRoutes } from '@app/router/routes/loyalty';
import { lpBonusRoutes } from '@app/router/routes/lpBonus';
import { marketingLandingRoutes } from '@app/router/routes/marketingLanding';
import { newsRoutes } from '@app/router/routes/news';
import { popularBetsRoutes } from '@app/router/routes/popularBets';
import { promotionsRoutes } from '@app/router/routes/promotions';
import { registerRoutes } from '@app/router/routes/register';
import { searchRoutes } from '@app/router/routes/search';
import { sportCallerRoutes } from '@app/router/routes/sportCaller';
import { superMillionRoutes } from '@app/router/routes/superMillion';
import { superShotRoutes } from '@app/router/routes/superShot';
import { superSpinRoutes } from '@app/router/routes/superSpin';
import { topManagerRoutes } from '@app/router/routes/topManager';
import { wikiRoutes } from '@app/router/routes/wiki';
import { calendarGameRoutes } from '@src/app/router/routes/calendarGame';
import { notificationsRoutes } from './notifications';

export const allShellRoutes: SuperbetRouteConfig[] = [
    ...marketingLandingRoutes,
    ...superSpinRoutes,
    ...newsRoutes,
    ...searchRoutes,
    ...accountRoutes,
    ...registerRoutes,
    ...wikiRoutes,
    ...promotionsRoutes,
    ...loyaltyRoutes,
    ...freeGamesRoutes,
    ...lpBonusRoutes,
    ...sportCallerRoutes,
    ...superMillionRoutes,
    ...fantasticDuelsRoutes,
    ...calendarGameRoutes,
    ...superShotRoutes,
    ...bingoBashRoutes,
    ...topManagerRoutes,
    ...notificationsRoutes,
    ...popularBetsRoutes,
];
